// tableUtils.js

export const getSortedData = (data, colName, direction) => {
  if (!colName || !direction) return data;

  return [...data].sort((a, b) => {
    // Access the nested 'row' object using the column name
    const valA = a.row[colName] ?? "";
    const valB = b.row[colName] ?? "";

    // Natural sort for numbers or strings
    const comparison = String(valA).localeCompare(String(valB), undefined, {
      numeric: true,
      sensitivity: 'base'
    });

    return direction === "asc" ? comparison : -comparison;
  });
};

// ... keep your getFilteredData and getPaginatedData logic similarly updated for .row access


export const getFilteredData = (rows, filters, topSearch) => {
  return rows.filter(row =>
    row.every((cell, idx) => {
      const f = filters[idx];
      if (!f) return true;

      if (f.includes("|")) {
        const allowed = f.split("|");
        return allowed.includes(String(cell));
      }

      return String(cell).toLowerCase().includes(f.toLowerCase());
    })
  ).filter(row =>
    topSearch
      ? row.some(cell => String(cell).toLowerCase().includes(topSearch.toLowerCase()))
      : true
  );
};

export const getPaginatedData = (rows, page, pageSize) => {
  const start = page * pageSize;
  const end = start + pageSize;
  return rows.slice(start, end);
};
